// client/src/utils/axios.js
// import axios from "axios";
// import config from "../config";

// const axiosInstance = axios.create({
//   baseURL: config.baseUrl,
//   withCredentials: true, // Ensure cookies are sent with requests
// });

// axiosInstance.interceptors.request.use(
//   (config) => {
//     const token = JSON.parse(localStorage.getItem("accessToken"));
//     if (token) {
//       config.headers["Authorization"] = `Bearer ${token.token}`;
//     }
//     return config;
//   },
//   (error) => Promise.reject(error)
// );

// export default axiosInstance;

// client/src/utils/axios.js
import axios from "axios";
import config from "../config";

const axiosInstance = axios.create({
  baseURL: config.baseUrl,
  withCredentials: true, // Ensure cookies are sent with requests
});

axiosInstance.interceptors.response.use(
  (response) => {
    // Ensure response data is handled correctly
    if (typeof response.data === "string" && response.data.startsWith("{")) {
      try {
        response.data = JSON.parse(response.data);
      } catch (e) {
        console.error("Error parsing JSON response:", e);
      }
    }
    return response;
  },
  (error) => {
    console.error("Response error:", error);
    return Promise.reject(error);
  }
);

export default axiosInstance;
